// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* IVA Panel styles */

/* Container inherits IDE theme variables */
`, "",{"version":3,"sources":["webpack://./src/components/IvaPanel/ivaPanel.css"],"names":[],"mappings":"AAAA,qBAAqB;;AAErB,2CAA2C","sourcesContent":["/* IVA Panel styles */\n\n/* Container inherits IDE theme variables */\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
